import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';
//import { ListPage } from '../../pages/list/list';
//import { ListPage } from '../pages/list/list';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
import { HomePage } from '../../pages/home/home';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker,
  Environment
} from '@ionic-native/google-maps';
@Component({
  selector: 'page-thanks',
  templateUrl: 'thanks.html'
})
export class ThanksPage {
  loading: Loading;
  countdown: number = 10;
  progress: number = 1; // 1 = 100%
  totalTime: number = 10;
  countdownInterval: any;
  



  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams) {
  }
  ionViewDidLoad() {
    // Starte Countdown beim Öffnen der Seite
    this.startCountdown();
  }
  startCountdown() {
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      this.progress = this.countdown / this.totalTime;
  
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.goToHome();
      }
    }, 1000);
  }
  goToHome() {
    clearInterval(this.countdownInterval); // sicherheitshalber stoppen
    this.navCtrl.setRoot(HomePage);
  }  
  
  //ionViewDidLoad() {  }

 
}



// WEBPACK FOOTER //
// ./src/pages/thanks/thanks.ts